import { PatstoreImage } from "@types";
import useGetImage from "./patstore/useGetImage";
import { getImage, IGatsbyImageData } from "gatsby-plugin-image";
import { graphql, useStaticQuery } from "gatsby";

const useFindImages = () => {
  const { images } = useGetImage();

  // Query for static placeholder image
  const placeholderData = useStaticQuery(graphql`
    query PlaceholderImage {
      file(relativePath: { eq: "tvstg_placeholder.png" }) {
        childImageSharp {
          gatsbyImageData(width: 1920, placeholder: BLURRED, formats: [WEBP])
        }
      }
    }
  `);

  const placeholder: IGatsbyImageData = getImage(
    placeholderData?.file?.childImageSharp?.gatsbyImageData,
  ) as IGatsbyImageData;

  const findImage: (id: string | null | undefined) => IGatsbyImageData = (
    id: string | null | undefined,
  ) => {
    const image = images.find(
      (image: PatstoreImage) => image.objectId === id,
    ) as PatstoreImage;

    if (!image) {
      return placeholder;
    }
    return getImage(image.localFile as any) || placeholder;
  };

  const findImageUrl: (id: string) => string | null = (id: string) => {
    const image = images.find((image: PatstoreImage) => image.objectId === id);

    if (!image) {
      return null;
    }

    return image?.localFile?.url || null;
  };

  return {
    findImage,
    findImageUrl,
    images,
  };
};

export default useFindImages;
